export default __webpack_public_path__ + "static/media/tzgg.698573d5.jpg";